module.exports = __webpack_public_path__ + "img/IDCard1.6cc35a1c.png";